import cn from 'classnames';
import {
  FC, InputHTMLAttributes, KeyboardEvent, ReactNode,
} from 'react';
import { IconProps } from 'semantic-ui-react';

import styles from './styles.module.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  value: string;
  error?: string
  handleChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  errorClassName?: string;
  label?: string;
  hint?: string;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  Icon?: FC<IconProps>;
  onClickIcon?: () => void;
  maxLength?: number;
  children?: ReactNode;
}

const Input: FC<Props> = ({
  value, handleChange, error, placeholder, className, label, hint,
  onKeyDown, Icon, onClickIcon, errorClassName, maxLength, children, ...props
}) => (
  <div className={cn(styles.wrap, className)}>
    {label && <div className={styles.label}>{label}</div>}
    <input
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      className={cn(styles.input, { [styles.withError]: error, [styles.withIcon]: Icon })}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
      {...props}
    />
    {Icon && <button className={styles.iconBtn} aria-label="icon" onClick={onClickIcon}><Icon className={styles.icon} /></button>}
    {error && <div className={cn(styles.error, errorClassName)}>{error}</div>}
    {hint && <div className={styles.hint}>{hint}</div>}
    {children}
  </div>
);

Input.defaultProps = {
  error: '',
  placeholder: undefined,
  className: '',
  label: '',
  hint: '',
  errorClassName: '',
};

export default Input;
